import * as React from "react";
import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LocalOfferIcon from "@material-ui/icons/LocalOfferOutlined";
import BarChartIcon from "@material-ui/icons/BarChart";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { FilterList, FilterListItem, FilterLiveSearch} from "react-admin";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";

const apiUrl = `${process.env.REACT_APP_SERVER_URL}`;
async function getData(setcategories) {
    const token = localStorage.getItem("token")
    const url = `${apiUrl}/categories/getList`;
    const response = await axios.get(url, { headers: {"Authorization" : `Bearer ${token}`} });
    setcategories(response.data.categories);
}

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up("sm")]: {
            width: "15em",
            marginRight: "1em",
            overflow: "initial",
        },
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
}));

const Aside = () => {
    const [categories, setcategories] = useState([]);

    useEffect(() => {
        getData(setcategories);
    }, []);

    const classes = useStyles();
    return (
        <Card className={classes.root} >
            <CardContent >
                <FilterLiveSearch source="name" />

                <FilterList label="Status" source="status" icon={<BarChartIcon />}>
                    <FilterListItem
                        label="For Rent"
                        value={{
                            is_for_rent: true,
                            is_for_sale: undefined,
                            is_procured: undefined,
                            is_rented: undefined,
                        }}
                    />
                    <FilterListItem
                        label="For Sale"
                        value={{
                            is_for_sale: true,
                            is_for_rent: undefined,
                            is_procured: undefined,
                            is_rented: undefined,
                        }}
                    />
                    <FilterListItem
                        label="Procured"
                        value={{
                            is_procured: true,
                            is_for_rent: undefined,
                            is_for_sale: undefined,
                            is_rented: undefined,
                        }}
                    />
                    <FilterListItem
                        label="Rented"
                        value={{
                            is_rented: true,

                            is_for_rent: undefined,
                            is_for_sale: undefined,
                            is_procured: undefined,
                        }}
                    />
                </FilterList>

                <FilterList label="Price Range" icon={<AttachMoneyIcon />}>
                    <FilterListItem
                        label="0$ -50$"
                        value={{
                            top: 50,
                            bot: 0,
                        }}
                    />
                    <FilterListItem
                        label="50$ -100$"
                        value={{
                            top: 100,
                            bot: 50,
                        }}
                    />
                    <FilterListItem
                        label="100$ -200$"
                        value={{
                            top: 200,
                            bot: 100,
                        }}
                    />
                    <FilterListItem
                        label="more than 200$"
                        value={{
                            top: undefined,
                            bot: 200,
                        }}
                    />
                </FilterList>

                <FilterList label="categories" icon={<LocalOfferIcon />}>
                    {categories &&
                        categories.map((category) => <FilterListItem label={category.category_name} key={category.id} value={{ category_id: category.id }} />)}
                </FilterList>
            </CardContent>
        </Card>
    );
};

export default Aside;
